/**
 * @name Get the length after the decimal point
 * @param {Number} Numbers to be converted
 */
export function digitLength(number) {
  return (number.toString().split('.')[1] || '').length;
}

/**
 * @name Remove decimal points from numbers
 * @param {Number} Numbers to be converted
 */
function floatToInt(number) {
  return Number(number.toString().replace('.', ''));
}

/**
 * @name Accuracy Calculation Multiplication
 * @param {Number} arg1 Multiplier 1
 * @param {Number} arg2 Multiplier 2
 */
export function multiply(arg1, arg2) {
  const baseNum = digitLength(arg1) + digitLength(arg2);
  const result = floatToInt(arg1) * floatToInt(arg2);
  return result / 10 ** baseNum;
}

/**
 * @name Accuracy calculation addition
 * @description JavaScript Error in addition result, two floating point numbers 0.1 + 0.2!== 0.3, this method can remove the error.
 * @param {Number} arg1 Plus 1
 * @param {Number} arg2 Plus 2
 * @return arg1 + arg2
 */
export function add(arg1, arg2) {
  const baseNum = 10 ** Math.max(digitLength(arg1), digitLength(arg2));
  return (multiply(arg1, baseNum) + multiply(arg2, baseNum)) / baseNum;
}

/**
 * @name Accuracy subtraction
 * @param {Number} arg1 Minus 1
 * @param {Number} arg2 Minus 2
 */
export function subtract(arg1, arg2) {
  const baseNum = 10 ** Math.max(digitLength(arg1), digitLength(arg2));
  return (multiply(arg1, baseNum) - multiply(arg2, baseNum)) / baseNum;
}

/**
 * @name Precision calculation Division
 * @param {Number} arg1 Divider 1
 * @param {Number} arg2 Divider 2
 */
function division(arg1, arg2) {
  const baseNum = 10 ** Math.max(digitLength(arg1), digitLength(arg2));
  return multiply(arg1, baseNum) / multiply(arg2, baseNum);
}
export function toFixed(val, floatsLength) {
  return Number(
    val
      .toString()
      .split('.')
      .map((v, i) => (i === 0 ? v : v.slice(0, floatsLength)))
      .join('.')
  );
}
